export const cilCommentSquare = ["24 24","<path d='M23.25 23.25h-2.214l-3.259-6h-15.902c-0.621-0.001-1.124-0.504-1.125-1.125v-14.25c0.001-0.621 0.504-1.124 1.125-1.125h20.25c0.621 0.001 1.124 0.504 1.125 1.125v0zM2.25 15.75h16.42l3.080 5.672v-19.172h-19.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-comment-square.js
// module id = null
// module chunks = 